import { Tag } from "@wfp/ui"
import BaseTable, { AutoResizer, ColumnShape } from "react-base-table"
import { CONTRACT_TYPE_LABELS, ContractType } from "services/aimsBackend"

type Row = { code: ContractType; label: string }

const ROWS: Row[] = (Object.entries(CONTRACT_TYPE_LABELS) as Array<[ContractType, string]>).map(([code, label]) => ({
  code,
  label,
}))

export default function ContractTypesTab() {
  const columns: Array<ColumnShape<Row>> = [
    { key: "code", dataKey: "code", title: "Code", width: 200, flexGrow: 0 },
    { key: "label", dataKey: "label", title: "Label", width: 300, flexGrow: 1 },
  ]

  return (
    <div className="mt-3">
      <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
        <Tag type="info" style={{ marginBottom: 0 }}>
          Read-only
        </Tag>
        <p className="m-0" style={{ fontSize: 13, color: "#5a6872" }}>
          Contract types are defined as a fixed enum in the backend. Adding, editing, or removing values requires a
          backend change.
        </p>
      </div>

      <div style={{ height: "100%", minHeight: "60vh", marginTop: 10 }}>
        <AutoResizer>
          {({ width, height }) => (
            <BaseTable
              data={ROWS}
              width={width}
              height={height}
              rowKey="code"
              className="custom-table"
              rowHeight={38}
              headerHeight={45}
              columns={columns}
              emptyRenderer={() => <p>No records to display</p>}
            />
          )}
        </AutoResizer>
      </div>
    </div>
  )
}
